import { Component, OnInit } from '@angular/core';
import { DynamicKpiDetailsHandler } from './dynamic-kpi-details.handler';
import { ContestAndIncentiveDetailsService } from '../services/contest-and-incentive-details.service';

@Component({
  selector: 'sym-dynamic-kpi-details',
  templateUrl: './dynamic-kpi-details.component.html',
  // styleUrls: ['./dynamic-kpi-details.component.scss'],
})
export class DynamicKpiDetailsComponent extends DynamicKpiDetailsHandler implements OnInit {
  constructor(service: ContestAndIncentiveDetailsService) {
    super(service);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
